import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import SideBarContainer from 'Containers/SideBarContainer';
import TabPage from 'Components/TabPage';
import useTranslation from 'Hooks/useTranslation';
import useUser from './Hooks/useUser';
import style from './style';
import DevelopmentPlan from './Pages/DevelopmentPlan';
import Profile from './Pages/Profile';

const { containerEmployee } = style;

export default function Employee() {
  const { t2 } = useTranslation('EmployeeAssess');
  const location = useLocation();
  const employee = location?.state?.user;
  const userInfo = useSelector(userSelector);
  const { user } = useUser(userInfo.id);
  const isAdmin = employee !== undefined;

  const tabsTitle = [t2('Employee'), t2('DevelopmentPlan')];

  // Se asigna al usuario o al empleado dependiendo si existe el empleado o no.
  const currentEmployee = employee === undefined ? user : employee;

  // Pestañas a mostrar en la página de "/EmployeeAssess"
  const pages = [
    <Profile key="profile" employee={currentEmployee} isAdmin={isAdmin} />,
    <DevelopmentPlan key="development-plan" employee={currentEmployee} isAdmin={isAdmin} />,
  ];

  return (
    <SideBarContainer>
      <div style={containerEmployee} className="col">
        <TabPage tabsTitle={tabsTitle} pages={pages} />
      </div>
    </SideBarContainer>
  );
}
